import React, { useContext, useEffect, useState } from "react";
import TargetTypeRadiobuttonElement from "./TargetTypeRadiobuttonElement";
import { TargetTypeContext } from "./TargetTypeTab";
import { connect } from "react-redux";
import { changeTargetTypeElement, patchTargetTypes } from "../addRuleStoreService";
import { sortObjectsByAlphabet } from "../../../utils";
import { Pagination } from "../../../view/Pagination";
import TargetTypeOptionsSkeleton from "./TargetTypeOptionsSkeleton";

const PAGE_SIZE = 25;

function TargetTypeRadiobuttonSection({ targetTypes, rule, disabled, searchTerm, loading }) {

    const { targetType } = useContext(TargetTypeContext);

    const [elements, setElements] = useState([]);
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const [currentPage, setCurrentPage] = useState(0);

    const onClick = (element) => {
        changeTargetTypeElement(targetType, element, rule);
        setLastUpdated(Date.now())
    }

    useEffect(() => {
        let types = patchTargetTypes(targetType, targetTypes, rule);
        if (targetType === 'MSB') {
            if (rule.deviceTypes[0]) {
                const selectedDviceTypeId = rule.deviceTypes[0].id;
                types = types.filter(item => item.deviceType && item.deviceType.id === selectedDviceTypeId);
            }
        }
        setElements(types);
        setCurrentPage(0); // reset page when type changes
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [targetType, lastUpdated, rule])

    // Reset page when search term changes
    useEffect(() => {
        setCurrentPage(0);
    }, [searchTerm]);

    // Filter by search term and sort
    const sorted = sortObjectsByAlphabet(elements, 'name');
    const filtered = searchTerm
        ? sorted.filter(el => el.name.toLowerCase().includes(searchTerm.toLowerCase()))
        : sorted;

    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const paginated = filtered.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

    if (loading) {
        return <TargetTypeOptionsSkeleton />;
    }

    return (
        <>
            <ul className="addrules-target-grid-v2">
                {paginated.map((el, index) =>
                    <TargetTypeRadiobuttonElement
                        element={el}
                        index={index}
                        key={index}
                        onClick={onClick}
                        disabled={
                            targetType === 'MSB' && el.baseMsb === true ? true : disabled
                        }
                    />
                )}
            </ul>

            {totalPages > 1 &&
                <Pagination
                    total={totalPages}
                    current={currentPage}
                    onClick={setCurrentPage}
                    totalRecords={filtered.length}
                />
            }
        </>
    )

}

function mapStateToProps(state) {
    const addRulePage = state.addRulesPage;
    const deviceTypes = addRulePage.deviceTypes || [];
    const msbList = addRulePage.msbList || [];
    return {
        rule: addRulePage.rule || {},
        targetTypes: { deviceTypes, msbList },
        loading: addRulePage.targetTypesLoading
        // msbList: addRulePage.msbList || []
    };

}

export default connect(mapStateToProps)(TargetTypeRadiobuttonSection);
